import React from "react";
import { View, StyleSheet } from "react-native";

//Custom Imports
import Label from "../Label";
import { fontFamily } from "@utils/styles";
import Text from "@components/CustomText";

const TextDisabled = ({ value, onSubmit, formItem = {} }) => {
  const { label = "", content = "" } = formItem;
  return (
    <>
      {label ? <Label label={label} /> : null}
      <View style={styles.textInputContainer}>
        <Text variant="caption_3" style={styles.textArea}>
          {content}
        </Text>
      </View>
    </>
  );
};

export default TextDisabled;

const styles = StyleSheet.create({
  textInputContainer: {
    borderWidth: 1,
    borderRadius: 6,
    borderColor: "rgba(0, 0, 0, 0.2)",
    backgroundColor: "white",
    padding: 15,
  },
  textArea: {
    fontFamily: fontFamily.regular,
    fontSize: 14,
    lineHeight: 22,
    justifyContent: "flex-start",
    textAlignVertical: "top",
  },
  planText: {
    fontFamily: fontFamily.regular,
    fontSize: 14,
    lineHeight: 22,
    alignSelf: "center",
    textAlignVertical: "top",
    marginTop: 32,
  },
});
